module.exports = __webpack_public_path__ + "static/media/2-燃脂塑形.22ca49ff.png";